import { render, staticRenderFns } from "./DeletedDealersTable.vue?vue&type=template&id=5ec703d4&scoped=true&"
import script from "./DeletedDealersTable.vue?vue&type=script&lang=js&"
export * from "./DeletedDealersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec703d4",
  null
  
)

export default component.exports